import { Fragment } from "react";
import clsx from "clsx";
import { TextBadge, Subtitle } from "components/atoms/Text";
import { listResidential } from "data/proxies";
import ResidentialCard from "components/organism/Cards/ResidentialCard";

const ResidentialProxies = () => {
    return (
        <Fragment>
            <section className="features relative w-full max-w-[1440px] flex justify-between mx-auto px-6 tablet:px-8 desktop:px-[120px] phone:pt-12 tablet:pb-12 tablet:pt-16 pt-[88px] phone:pb-8 pb-16 bg-neutral-10">
                <section className={clsx(
                    "w-full max-w-full tablet:max-w-[606px] desktop:max-w-[616px]",
                    "px-0"
                )}>
                    <TextBadge>Residential Proxies</TextBadge>
                    <h1 className="font-semibold text-neutral-100 text-heading-3 phone:text-[32px] phone:leading-[48px] leading-[54px] tracking-text-sm">Buy Cheap, Dedicated and Fully Anonymous Residential Proxies</h1>
                    <Subtitle classNames="pt-4 desktop:max-w-[590px] !leading-[27.2px] phone:!leading-[27.2px] phone:!text-[16px]">A residential proxy is a proxy that appears as being allocated by an Internet Service Provider (ISP) and generally indicates that a real person is behind the IP address. Residential proxies are much harder to get because they are only tied to real internet users and do not sit on a server.</Subtitle>
                </section>
                <img src="/images/universal/brick-residential.svg" className="block phone:hidden w-[194px] h-[216px] tablet:w-[137px] tablet:h-[153px] tablet:mr-0 mr-[42px] absolute top-[67px] right-[120px] tablet:top-16 tablet:right-[81px]" alt="brick" />
            </section>

            <section className="features relative w-full max-w-[1440px] flex justify-between mx-auto px-6 tablet:px-8 desktop:px-[120px] bg-neutral-10 tablet:pb-16 phone:pb-12 pb-[96px]">
                <div className="w-full flex flex-col phone:space-y-6 space-y-10 tablet:space-y-8">
                    {listResidential.slice(0, 1).map((item) => (
                        <ResidentialCard key={item.id} img={item.image} title={item.title} description={item.description} classNames="tablet:max-w-[470px]" imageClassnames="desktop:!w-[397px] desktop:!max-w-[397px]" />
                    ))}
                    {listResidential.slice(1, 2).map((item) => (
                        <ResidentialCard key={item.id} img={item.image} imageClassnames="scale-[.87]" title={item.title} description={item.description} classNames="tablet:max-w-[450px]" titleWidth="tablet:max-w-[364px]" />
                    ))}
                </div>
            </section>
        </Fragment>
    );
};

export default ResidentialProxies;